import type { AnalyticsProvider } from '../types';

export class MetaPixelProvider implements AnalyticsProvider {
  readonly name = 'metaPixel' as const;
  readonly requiresConsent = true;

  isAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.fbq === 'function';
  }

  initialize(): void {
    // Meta Pixel is loaded via server-injected script, no initialization needed
  }

  track(eventName: string, payload: Record<string, unknown>): void {
    if (!window.fbq) return;
    window.fbq('track', eventName, payload);
  }
}
